import { render, staticRenderFns } from "./changepostt.vue?vue&type=template&id=4231f8df&scoped=true&"
import script from "./changepostt.vue?vue&type=script&lang=js&"
export * from "./changepostt.vue?vue&type=script&lang=js&"
import style0 from "./changepostt.vue?vue&type=style&index=0&id=4231f8df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4231f8df",
  null
  
)

export default component.exports